import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=5731f32c&"
import script from "./CheckInfo.vue?vue&type=script&lang=js&"
export * from "./CheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./CheckInfo.vue?vue&type=style&index=0&id=5731f32c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports